var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"preview__wrapper"},[_c('p',[_vm._v("Preview")]),_c('div',{staticClass:"tag__preview",style:({color: _vm.color, backgroundColor: _vm.backgroundColor})},[_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.name))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }